import { findNode } from 'slate-react'

import {
  NODE_TYPE as NT,
  // receivableTypes,
} from 'shared/constants/slate';


export const HandleImage = (opts) => {

  const onDrop = (event, change, editor) => {
    const { value } = change;
    const { document: doc } = value;

    const target = findNode(event.target, value);
    const tlb = doc.getFurthestBlock(target.key) || target;
    if (tlb.type === NT.paragraph) return;

    // const images = value.blocks.filter(b => receivableTypes.includes(b.type));
    const images = value.blocks.filter(b => b.type === NT.image);
    const key = event.dataTransfer.getData('key');
    if (images.size === 0 && !key) {
      return;
    }

    return change;
  }

  return {
    onDrop,
  };
}



// WEBPACK FOOTER //
// ./src/components/slate/plugins/HandleImage.js